type PageObject = {
  name: string
  description: string
}

type ImpactModulePages = {
  [key: string]: PageObject
}

export const ALERTS_OF_VULNERABILITY_PAGES: ImpactModulePages = {
  CASE: {
    name: 'Alertas',
    description: 'Gestão das alertas',
  },
  ALERT_TYPE: {
    name: 'Tipos de alertas',
    description: 'Gestão dos tipos de alerta',
  },
  ALERT_FOLLOW_UP: {
    name: 'Monitoramentos do alerta',
    description: 'Gestão dos monitoramentos do alerta',
  },
  ALERT_FOLLOW_UP_ACTION: {
    name: 'Ações de monitoramento do alerta',
    description: 'Gestão das ações de monitoramento',
  },
  DASHBOARD: {
    name: 'Relatório geral',
    description: 'Gestão dos relatórios',
  },
  GROUP_MODULE_PERMISSION: {
    name: 'Permissões de grupo',
    description: 'Gestão das permissões de grupos',
  },
  PUBLIC_AGENT_MODULE_PERMISSION: {
    name: 'Permissões de agentes',
    description: 'Gestão das permissões dos agentes',
  },
}
